import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import  MdOutlineDeleteOutline  from "../../Assests/delete-02-stroke-rounded.svg";
import { FaAward, FaDoorOpen } from "react-icons/fa6";
import { FaRegUserCircle } from "react-icons/fa";
import requestOrder from "../../Assests/time-quarter-pass-stroke-rounded (1).svg"
import view from "../../Assests/file-view-stroke-rounded.svg"
import { RxUpdate } from "react-icons/rx";
import { convertToCSV, download } from '../../lib/utils/export';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import { numberOfData } from '../../lib/definitions';
import DropDown from '../GDropDownList/DropDown';
import toast from 'react-hot-toast';
import i18n from '../../lib/i18n';
import NotData from '../../ui/sharedUi/noData';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import { FiEdit } from "react-icons/fi";
import { AiFillThunderbolt } from "react-icons/ai";

const getNestedValue = (obj, path) => {
  return path?.split('.')?.reduce((acc, part) => acc && acc[part], obj);
};

const Table = ({ columns, rows, edit, openDeleteConfirmation, openConfirmation, openBadgeConfirmation, openBoostConfirmation, openOrderDetails, action, confirmReport, loadingReport, name, showExportDialog, openCloseExportDialog, ExportTableWithPaginiation, rowsExportPaginiation }) => {

  const nav = useNavigate();
  const [exportValue, setExportValue] = useState(null);
  const t = i18n.t.bind(i18n);
  const currentLang = i18n.language;

  const onChangeExportValue = (e) => {
    setExportValue(e);
  };

  const getValue = (item, key) => item && item[key] !== undefined ? item[key] : "";

  useEffect (()=>{
    let keys = [];
    if(rowsExportPaginiation?.length > 1){
        keys = columns.map(col => col.key);
        const dataToExport = rowsExportPaginiation.map(item =>
            keys.reduce((acc, key) => {
            acc[key] = getValue(item, key);
            return acc;
            }, {})
        );
        const csv = convertToCSV(dataToExport, columns);
        const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
        const filename = `${name}-${timestamp}.csv`;
        download(filename, csv);
        setExportValue(null);
        openCloseExportDialog(false);
    };
  },[rowsExportPaginiation])

  const ExportCSV = () => {
      const keys = columns.map(col => col.key);
      const dataToExport = rows.map(item =>
          keys.reduce((acc, key) => {
          acc[key] = getValue(item, key);
          return acc;
          }, {})
      );
      const csv = convertToCSV(dataToExport, columns);
      const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
      const filename = `${name}-${timestamp}.csv`;
      download(filename, csv);
      setExportValue(null);
      openCloseExportDialog(false);
  };

  const handleExportValue = () => {
    if(exportValue){
      ExportTableWithPaginiation(exportValue);
    }
    else {
      toast.error("please select the number of records");
    }
  };

  const handleNavEdit = (id) => {
    nav(`${edit}/${id}`);
  };

  const handleDeleteRecode = (id) => {
    openDeleteConfirmation(id);
  };

  const handleConfirmRecord = (id) => {
    openConfirmation(id);
  };

  const handleCompleteReport = (id) => {
    confirmReport(id);
  };

  const handleOpenDetailsPop = (id) => {
    openOrderDetails(id);
  };

  const onClose = () => {
    openCloseExportDialog(false);
  };

  const safeSlice = (value, length = 50) => {
  if (typeof value === "string") return value.slice(0, length);
  if (Array.isArray(value)) return value.slice(0, length);
  return value;
};


  if(rows.length < 1){
    return <NotData />
  }

  return (
    <div className="overflow-x-auto scrollable">
      {showExportDialog && 
        <div className='fixed inset-0 bg-black/60 flex items-center justify-center z-40'>
          <div>
              <div className="bg-[#1f2937] text-center rounded-2xl shadow-lg w-full p-6 relative overflow-y-auto max-h-[86vh] scrollable">
                <button onClick={onClose} className="absolute top-3 left-4 text-gray-500 hover:text-red-500 text-xl">
                  ✕
                </button>
                <h1 className='text-white text-lg pt-6'>{currentLang == "en" ? "This method allows you to export the table to a CSV file." : "هذه العملية تمكنك من تصدير الجدول لملف CSV"}</h1>
                <p className='text-white text-md py-4 mb-4 text-center'>{currentLang == "en" ? "Choose an export format" : "اختر شكل التصدير"}</p>
                <div className='flex justify-between items-center pb-2'>
                  <h1 className='text-white'>1-</h1>
                  <div className='w-56'>
                    <DropDown options={numberOfData} value={exportValue} onchange={onChangeExportValue} defaultText={currentLang == "en" ? "Select number of results" : "اختر عدد النتائج"} paramkey="per_page" />
                  </div>
                  <button onClick={handleExportValue} className="px-5 py-2  rounded-md bg-secondary">{currentLang == "en" ? "With indexing" : "مع فهرسة "}</button>
                </div>
                <div className='border-b border-gray-500/40 w-[60%] m-auto text-center'><h1 className='relative top-3 text-sm text-white'>{currentLang == "en" ? "OR" : "أو"}</h1></div>
                <div className='flex justify-start items-center mt-7'>
                  <h1 className='text-white'>2-</h1>
                  <button onClick={ExportCSV} className="px-4 py-2 ms-7 w-full text-center rounded-md bg-gray-400 ">  {currentLang == "en" ? "Unindexed" : "بدون فهرسة "} </button>
                </div>
              </div>
          </div>
        </div>
      }
      <table className="w-full bg-thirdly border-collapse rounded-lg shadow-md">
        <thead className="bg-furthly">
          <tr className="text-white text-center">
            {columns.map((column, index) => (
              <th
                key={index}
                className="px-4 py-4 font-semibold text-[15px]"
              >
                {column.header}
              </th>
            ))}
            <th className="px-4 py-4 font-semibold text-[15px]">
              {t("columns.options")}
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="text-center transition"
            >
              {columns.map((column, colIndex) => {
                const rawValue = getNestedValue(row, column.key);
                const value =
                  (typeof rawValue === "string" &&
                    column.header !== "الصورة" &&
                    column.header !== "Photo" &&
                    column.header !== "Icon" &&
                    column.header !== "الايقونة"
                  )
                    ? rawValue.slice(0, 50)
                    : rawValue;

                return (
                  <td
                      key={colIndex}
                      className={`px-4 py-3 ${value == "PENDING" ? "text-warning" : value == "CONFIRM" ? "text-success" : value == "REJECT" ? "text-danger" : value == "SoldRemoved" ? "text-blue-600" :
                         (value == true && column.key != "required" && column.header != "المعرف" && column.header != "ID" && column.header != "Parent ID" && column.header != "معرف الأب" && column.header != "Price" && column.header != "السعر"  && column.header != "مكان الظهور" && column.header != "Position") 
                         ? "text-success" 
                         : (value == false && column.key != "required" && column.header != "المعرف" && column.header != "ID" && column.header != "Parent ID" && column.header != "معرف الأب" && column.header != "السعر" && column.header != "Price" && column.header != "مكان الظهور" && column.header != "Position") 
                         ? "text-danger" 
                         : "text-white" } text-[15px] border-b border-gray-500/40`}
                    >
                      {/* --- UPDATED: Photo Rendering with Overlay Badge --- */}
                      {
                      (column.header === "الصورة" || column.header === "Photo") && (value != null) ? (
                        <div className="relative w-12 h-11 m-auto">
                          <img
                            className="w-full h-full rounded-md object-cover"
                            src={value}
                            alt="userPhoto"
                          />
                          {action === "users" && row.badge_icon && (
                            <img
                              src={row.badge_icon}
                              alt="Badge"
                              className="absolute -top-2 -right-2 w-5 h-5 rounded-full object-cover shadow-md z-10"
                            />
                          )}
                        </div>
                      ) :
                      (column.header === "الايقونة" || column.header === "Icon") && (value != null) ? (
                        <div className="relative w-12 h-11 m-auto">
                          <img
                            className="w-full h-full rounded-md object-cover"
                            src={value}
                            alt="userPhoto"
                          />
                        </div>
                      )
                        : (column.header == t("columns.user_by_name")) ? <Link className='text-orange-400' to={`/users/details/${row?.user_by?.id}`}>{value}</Link> 
                        : (column.header == t("columns.reported_user_name")) ? <Link className='text-orange-400' to={`/users/details/${row?.reported_user?.id}`}>{value}</Link> 
                        : (column.header == t("columns.ad_name") && value ) ? <Link className='text-blue-400' to={`/users/details/${row?.reported_user?.id}?id=${row?.reported_ad?.id}`}>{value}</Link>  
                        : (column.header == t("columns.full_name")) ? <Link className='text-orange-400' to={`/users/details/${row?.user_id || row?.id}`}>{value}</Link>  
                        
                        /* --- UPDATED: Fallback Icon Rendering with Overlay Badge --- */
                        : (column.header === "الصورة"|| column.header === "Photo") && value == null ? (
                        <div className='relative w-12 h-11 m-auto flex justify-center items-center'>
                          <FaRegUserCircle className='text-[30px] text-gray-400'/>
                          {action === "users" && row.badge_icon && (
                            <img
                              src={row.badge_icon}
                              alt="Badge"
                              className="absolute -top-2 -right-1 w-5 h-5 rounded-full object-cover shadow-md z-10"
                            />
                          )}
                        </div>
                      ) : value == null ? (
                        "-"
                      ) : (column.header === "الحالة" || column.header === "Status") && value === true ? (
                        currentLang === "en" ? "active" : "فعال"
                      ) : (column.header === "الحالة" || column.header === "Status") && value === false ? (
                        currentLang === "en" ? "un active" : "غير فعال"
                      ) : (column.header === "الإجراء المتخذ" || column.header === "Action Taken") && value === true ? (
                        currentLang === "en" ? "Repaired" : "تم الإصلاح"
                      ) : (column.header === "الإجراء المتخذ" || column.header === "Action Taken") && value === false ? (
                        currentLang === "en" ? "Not Repaired" : "لم يتم الإصلاح"
                      ) : column.key === "have_badge" && value === false ? (
                        currentLang === "en" ? "No" : "لا يوجد"
                      ) : column.key === "have_badge" && value === true ? (
                        currentLang === "en" ? "Yes" : "يوجد"
                      ) : column.key === "topResult" && value === false ? (
                        currentLang === "en" ? "unactive" : "غير فعال"
                      ) : column.key === "topResult" && value === true ? (
                        currentLang === "en" ? "avtive" : "فعال"
                      ) : column.key === "isHome" && value === false ? (
                        currentLang === "en" ? "disappears" : "لا يظهر"
                      ) : column.key === "is_boosted" && value === true ? (
                        currentLang === "en" ? "Yes" : "فعال"
                      ) : column.key === "is_boosted" && value === false ? (
                        currentLang === "en" ? "No" : "غير فعال"
                      ) : column.key === "isHome" && value === true ? (
                        currentLang === "en" ? "appears" : "يظهر"
                      ) : column.key === "confirmed" && value === false ? (
                        currentLang === "en" ? "unauthenticated" : "غير موثق"
                      ) : column.key === "confirmed" && value === true ? (
                        currentLang === "en" ? "authenticated" : "موثق"
                      ) : column.key === "position" && value == 1 ? (
                        currentLang === "en" ? "normal position" : "ظهور عادي"
                      ) : column.key === "duration" ? (
                        `${value} يوم`
                      ) : column.key === "position" && value == 2 ? (
                        currentLang === "en" ? "home page position" : "ظهور في الصفحة الرئيسية" 
                      ) : column.key === "required" && value === true ? (
                        currentLang === "en" ? "Require" : "اجباري"
                      ) : column.key === "required" && value === false ? (
                        currentLang === "en" ? "Optional" : "اختياري"
                      ) : typeof value === "object" ? (
                        value.ar || value.en || JSON.stringify(value)
                      ) : (
                        value
                      )}
                  </td>
                );
              })}
              <td className="px-4 py-3 h-full text-gray-800 border-b border-gray-500/40">
                <div className="flex flex-row justify-around gap-3">
                  {(openConfirmation && action =="confirm") &&
                    <img
                      src={requestOrder}
                      className="h-6 text-white cursor-pointer"
                      // onClick={handleExportCurrentView}
                      onClick={() => handleConfirmRecord(row.id)}
                    />
                  }
                  {( action =="detailsAds") &&
                  (<>
                    <FiEdit
                      className="h-5 w-10 text-white cursor-pointer"
                      onClick={() => handleNavEdit(row.id)}
                    />
                    <AiFillThunderbolt
                      className="h-5 w-10 text-white cursor-pointer"
                      onClick={() => openBoostConfirmation(row)}
                    />
                    <img
                      src={view}
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleOpenDetailsPop(row.id)}
                    />
                    <img
                      src={MdOutlineDeleteOutline}
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleDeleteRecode(row.id)}
                    />
                  </>)
                  }
                  {( action =="users") &&
                  (<>
                    <FaAward
                      className="h-5 w-10 text-white cursor-pointer"
                      onClick={() => openBadgeConfirmation(row.id, row.have_badge, row.full_name)}
                    />
                    <FiEdit
                      className="h-5 w-10 text-white cursor-pointer"
                      onClick={() => handleNavEdit(row.id)}
                    />
                    <img
                      src={MdOutlineDeleteOutline}
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleDeleteRecode(row.id)}
                    />
                  </>)
                  }
                  {( action =="boostedAds") &&
                  (<>
                    <AiFillThunderbolt
                      className="h-5 w-10 text-white cursor-pointer"
                      onClick={() => openBoostConfirmation(row)}
                    />
                    <img
                      src={view}
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleOpenDetailsPop(row.id)}
                    />
                  </>)
                  }
                  {action =="confirm" &&
                    <img
                      src={view}
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleOpenDetailsPop(row.id) }
                    />
                  }
                  {action =="payment" &&
                    <RxUpdate
                      className="h-5 text-white cursor-pointer"
                      onClick={() => handleConfirmRecord(row.id)}
                    />
                  }
                  {action =="reports" && 
                  ( !loadingReport
                    ? (row.check == false ? <ThumbUpOffAltIcon onClick={() => handleCompleteReport(row.id)} className='text-white cursor-pointer' /> : <ThumbDownOffAltIcon onClick={() => handleCompleteReport(row.id)} className='text-white cursor-pointer' />)
                    : <HourglassBottomIcon
                        className="h-5 text-gray cursor-pointer"
                      />
                  )
                  }
                  {action === "permissions" ? (
                    <FaDoorOpen
                      className="text-[18px] text-white cursor-pointer"
                      onClick={() => handleNavEdit(`permissions/${row.id}`)}
                    />
                  ) : null}
                  {(action != "confirm" && action != "detailsAds" && action != "users" && action != "payment" && action != "reports" && action != "boostedAds") &&
                    <>
                      <FiEdit
                        className="text-[18px] text-white cursor-pointer"
                        onClick={() => handleNavEdit(row.id)}
                      />
                    <img
                      src={MdOutlineDeleteOutline}
                        className="h-5 text-white cursor-pointer"
                        onClick={() => handleDeleteRecode(row.id)}
                      />
                    </>
                  }
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;